import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, InputAdornment, Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import { Add, AddCircle, ArrowDropDown, ArrowDropUp, Close, Delete, Done, Edit, Error, Save } from "@mui/icons-material";
import { deleteItems, updateStateData } from "../../../Store/actions";
import {
  checkUncheckAllCheckboxes,
  validate_adlevel_accuracy,
  validate_adlevel_for_all_checks,
} from "../../../api_calls/campaignSheet";
import ActionButton from "../../../components/commonComponents/Buttons/ActionButton";
import { ListingCellCenter, ListingCellContent, ListingCellLeft, ListingCellRight, ListingHeaderContent, ListingIconMetric, ListingTableCellForNoRecordFound, MediumWidthStyledTableCell, NormalWidthStyledTableCell, StyledTableCell } from "../../../components/commonComponents/TabularLists/styles";
import {
  HtmlTooltip,
  HtmlTooltipDisabled,
  IconContainer,
  SpaceBetweenStack,
  StyledCheckbox,
  StyledStack,
  StyledWhiteCheckbox,
} from "../../../components/commonComponents/StyledComponents/styled";
import { CustomTextInput, CustomTextInputLeftAligned } from "../../../components/commonComponents/TextInputs/style";
import CloseButton from "../../../components/commonComponents/Buttons/CloseButton";
import { toast } from "react-toastify";
import { deleteMultipleAdlevels, saveSingleAdlevelRow, updateCampaignAdlevels } from "../../../api_calls/campaignRequests";
import DownloadCSV from "../../../components/commonComponents/DownloadCsv/DownloadCSV";
import { DisabledGreyButton } from "../../../components/commonComponents/Buttons/DisabledButton";
import CommonConfirmation from "../../../components/commonComponents/CommonConfirmation";
import Pagination from "../../../components/commonComponents/LoadMore/Pagination";
import ListingDataTableForModal from "../../../components/commonComponents/TabularLists/ListingDataTableForModal";
import { maxWidth } from "@mui/system";
import { SortIcon } from "../../../api_calls/utils";


const AdlevelSheetResults = (props) => {
  const sheetDetails = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [editRow, setEditRow] = React.useState(false);
  const [editRowIndex, setEditRowIndex] = React.useState("");
  //use react state to manage product selections for creating adlevels.
  const [productSelection, setProductSelection] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  // to show error when there's any inaccuracy found in ad level names and numbers
  const [accuracyErrors, setAccuracyErrors] = React.useState({});
  const [error, setError] = React.useState(false);
  const readCampaignStatus =
    typeof sheetDetails.campaign_detail !== "undefined" &&
      ![2, 4].includes(sheetDetails.campaign_detail.campaign_status_code)
      ? "requested"
      : "open";

  const [searchVal, setSearchVal] = React.useState({ value: "" });
  const [editedRowValues, setEditedRowValues] = React.useState({});
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [addNewRow, setAddNewRow] = React.useState({
    add: false,
    addFrom: "",
  });
  const [newRowValues, setNewRowValues] = React.useState({
    record_index: "",
    nameCompany: "",
    campaign: "",
    bundleSize: "",
    nameAdLevel: "",
    numberAdLevel: "",
    gtin: "",
    description: "",
  });
  // sorting measures for files listing
  const [sortingMeasure, setSortingMeasure] = React.useState({
    nameAdLevel: "asc",
    numberAdLevel: "asc",
    description: "asc",
    gtin: "asc",
  });
  const [sortingParamName, setSortingParamName] = React.useState("numberAdLevel");

  const paginationStartValue =
    typeof sheetDetails.pagination !== "undefined" ? sheetDetails.pagination.analysis_import_start : 0;
  const paginationEndValue =
    typeof sheetDetails.pagination !== "undefined" ? sheetDetails.pagination.analysis_import_end : 10;

  const listingRecords = typeof sheetDetails.created_adlevels !== "undefined" ? typeof searchVal.value !== "undefined" && searchVal.value !== ""
    ? sheetDetails.created_adlevels.filter((sheetData) => {
      if (parseInt(searchVal.value) !== "NaN" && searchVal.value.length <= 2) {
        return sheetData.numberAdLevel.toString().includes(searchVal.value.toString()) ||
          sheetData.bundleSize.toString().includes(searchVal.value.toString());
      } else {
        return (
          sheetData.nameAdLevel.toLowerCase().includes(searchVal.value.toLowerCase().toString()) ||
          sheetData.numberAdLevel.toString().includes(searchVal.value.toString()) ||
          sheetData.description.toLowerCase().includes(searchVal.value.toLowerCase().toString()) ||
          sheetData.gtin.toString().includes(searchVal.value.toString()) ||
          sheetData.bundleSize.toString().includes(searchVal.value.toString())
        );
      }
    }) : sheetDetails.created_adlevels : [];

  // to return the sorted list items
  const sortedResults = (toBeSortedList) => {
    return toBeSortedList.slice().sort((a, b) => {
      if (sortingParamName === "numberAdLevel") {
        return sortingMeasure.numberAdLevel === "asc"
          ? parseInt(a.numberAdLevel) - parseInt(b.numberAdLevel)
          : parseInt(b.numberAdLevel) - parseInt(a.numberAdLevel);
      } else if (sortingParamName === "nameAdLevel") {
        return sortingMeasure.nameAdLevel === "asc"
          ? a.nameAdLevel.localeCompare(b.nameAdLevel)
          : b.nameAdLevel.localeCompare(a.nameAdLevel);
      } else if (sortingParamName === "description") {
        return sortingMeasure.description === "asc"
          ? a.description.localeCompare(b.description)
          : b.description.localeCompare(a.description);
      } else {
        return sortingMeasure.gtin === "asc" ? parseInt(a.gtin) - parseInt(b.gtin) : parseInt(b.gtin) - parseInt(a.gtin);
      }
    });
  };
  //select records from redux
  const sheetRecords = sortedResults(listingRecords).slice(paginationStartValue, paginationEndValue);

  // will be used when we approve edited changes in the edit row format
  const handleFieldChange = async (dataIndex) => {
    const adlevelRecords = typeof sheetDetails.created_adlevels !== "undefined" ? sheetDetails.created_adlevels : [];
    setError(false);
    setAccuracyErrors({});
    // validate edited values
    const checkValidity = validate_adlevel_for_all_checks(editedRowValues.edited_values);
    if (checkValidity.error === true) {
      setError(true);
      setAccuracyErrors(checkValidity.messagesObj);
    } else {
      // validate accuracy
      const checkAccuracy = validate_adlevel_accuracy(
        editedRowValues.edited_values,
        adlevelRecords.filter((item) => {
          return item.record_index !== dataIndex;
        })
      );

      if (checkAccuracy.error === true) {
        setError(true);
        setAccuracyErrors(checkAccuracy.messagesObj);
      } else {
        const trimmedValues = {
          ...editedRowValues.edited_values,
          description: editedRowValues.edited_values.description.trim(),
          nameAdLevel: editedRowValues.edited_values.nameAdLevel.trim(),
        }

        const saveRecords = await updateCampaignAdlevels([trimmedValues]);
        if (saveRecords.success === true) {
          // check if any error returned from the api
          if (
            typeof saveRecords.api_response !== "undefined" &&
            typeof saveRecords.api_response.response.success !== "undefined" &&
            saveRecords.api_response.response.success === false
          ) {
            toast(saveRecords.api_response.response.error_detail, { type: "error" });
          } else {
            const updatedAdlevelSheetRecords = [
              ...adlevelRecords.slice(0, dataIndex), // Copy elements before the updated index
              trimmedValues, // Update the element at the specified index
              ...adlevelRecords.slice(dataIndex + 1), // Copy elements after the updated index
            ];

            dispatchAction(
              updateStateData({
                created_adlevels: updatedAdlevelSheetRecords,
              })
            );

            setEditRow(false);
            setEditRowIndex("");
            setEditedRowValues({});
            props.setChangesInProgress(false);
            //show success notification
            const message = "Analysis group updated successfully.";
            toast(message, { type: "success" });
            //reset filter and reset all selected checkboxes
            checkUncheckAllCheckboxes(false);
          }
        }
      }
    }
  };

  // will be used to add a new adlevel records
  const addNewRecord = async (addFrom) => {
    const adlevelRecords = typeof sheetDetails.created_adlevels !== "undefined" ? sheetDetails.created_adlevels : [];
    setError(false);
    setAccuracyErrors({});
    const checkValidity = validate_adlevel_for_all_checks(newRowValues);
    if (checkValidity.error === true) {
      setError(true);
      setAccuracyErrors(checkValidity.messagesObj);
    } else {
      // validate accuracy
      const checkAccuracy = validate_adlevel_accuracy(newRowValues, adlevelRecords);

      if (checkAccuracy.error === true) {
        setError(true);
        setAccuracyErrors(checkAccuracy.messagesObj);
      } else {
        const trimmedValues = {
          ...newRowValues,
          nameCompany: props.retailer,
          campaign: props.campaignId,
          description: newRowValues.description.trim(),
          nameAdLevel: newRowValues.nameAdLevel.trim(),
        }

        const saveRecords = await saveSingleAdlevelRow(
          props.campaignId,
          [trimmedValues],
          sheetDetails.campaign_detail.campaign_status_code
        );
        if (saveRecords.success === true) {
          // check if any error returned from the api
          if (
            typeof saveRecords.api_response !== "undefined" &&
            typeof saveRecords.api_response.response.success !== "undefined" &&
            saveRecords.api_response.response.success === false
          ) {
            toast(saveRecords.api_response.response.error_detail, { type: "error" });
          } else {
            const updatedAdlevelSheetRecords =
              addFrom === "top"
                ? [
                  trimmedValues, // add new record to the top
                  ...adlevelRecords,
                ]
                : [
                  ...adlevelRecords,
                  trimmedValues, // add new record to the end
                ];

            dispatchAction(
              updateStateData({
                created_adlevels: updatedAdlevelSheetRecords.map((value, key) => {
                  return {
                    ...value,
                    record_index: key,
                  };
                }),
              })
            );

            // reset uploaded file data (if any)
            dispatchAction(deleteItems(["adlevel_sheet_data", "uploaded_sheet_errors"]));
            props.controlAcceptedFiles([]);
            props.controlRejectedFiles([]);

            setAddNewRow({
              add: false,
              addFrom: "",
            });

            setNewRowValues({
              record_index: "",
              nameCompany: "",
              campaign: "",
              bundleSize: "",
              nameAdLevel: "",
              numberAdLevel: "",
              gtin: "",
              description: "",
            });
            props.setChangesInProgress(false);
            const message = "Analysis group added successfully.";
            toast(message, { type: "success" });
          }
        }
      }
    }
  };

  const afterDeleteAction = () => {
    const adlevelRecords = typeof sheetDetails.created_adlevels !== "undefined" ? sheetDetails.created_adlevels : [];
    const newAdlevelList = adlevelRecords.filter((sheetRecord) => {
      return !productSelection.includes(sheetRecord.record_index);
    });
    // update redux state
    dispatchAction(
      updateStateData({
        created_adlevels: newAdlevelList.map((value, key) => {
          return {
            ...value,
            record_index: key,
          };
        }),
      })
    );
    checkUncheckAllCheckboxes(false);
    //reset product selection
    setProductSelection([]);
    setSelectAll(false);
    //show success notification
    toast("Analytics product deleted successfully.", { type: "success" });
  };

  // delete selected records
  const deleteSelectedItems = async () => {
    const adlevelRecords = typeof sheetDetails.created_adlevels !== "undefined" ? sheetDetails.created_adlevels : [];
    let toBeDeletedRecordIds = [];
    let recordsWithoutId = false;
    let recordsWithId = false;

    adlevelRecords.forEach((record) => {
      if (productSelection.includes(record.record_index)) {
        if (typeof record.id !== "undefined") {
          recordsWithId = true;
          toBeDeletedRecordIds.push({
            id: record.id,
          });
        } else {
          recordsWithoutId = true;
        }
      }
    });

    if (recordsWithId === true) {
      const deleteAdlevelRecord = await deleteMultipleAdlevels(toBeDeletedRecordIds);

      if (deleteAdlevelRecord.success === true) {
        afterDeleteAction();
      } else {
        //show error notification
        toast("Sorry, something went wrong.", { type: "error" });
      }
    }

    if (recordsWithoutId === true) {
      afterDeleteAction();
    }
  };

  const cancelAddingNewRow = () => {
    setError(false);
    setAccuracyErrors({});
    setNewRowValues({
      record_index: "",
      nameCompany: "",
      campaign: "",
      bundleSize: "",
      nameAdLevel: "",
      numberAdLevel: "",
      gtin: "",
      description: "",
    });
    setAddNewRow({
      add: false,
      addFrom: "",
    });
    props.setChangesInProgress(false);
  };

  const csvHeaders = [
    { label: "group_number", key: "numberAdLevel" },
    { label: "group_name", key: "nameAdLevel" },
    { label: "description", key: "description" },
    { label: "gtin", key: "gtin" },
    { label: "bundle_size", key: "bundleSize" },
  ];

  const tooltipError = (fieldError) => {
    return (
      <div>
        <HtmlTooltip title={fieldError}>
          <IconContainer>
            <Error aria-label={fieldError} fontSize="small" sx={{ color: "#AF3241", marginTop: "7px" }} />
          </IconContainer>
        </HtmlTooltip>
      </div>
    );
  };

  const canEdit =
    typeof sheetDetails.campaign_detail !== "undefined" &&
    ![2, 4].includes(sheetDetails.campaign_detail.campaign_status_code);

  const rows = React.useMemo(() => {
    const base = sheetRecords.length !== 0 ? sheetRecords : [
      // { __rowType: "empty_row", record_index: "__no_records__" }
    ];

    // if add new row is triggered from top, render the new row jsx at the top of the list
    if (addNewRow.add === true && addNewRow.addFrom === "top") {
      return [{ __rowType: "add_top", record_index: "__add_top__" }, ...base];
    }

    if (addNewRow.add === true && addNewRow.addFrom === "bottom") {
      return [...base, { __rowType: "add_bottom", record_index: "__add_bottom__" }];
    }
    // append a synthetic row at bottom to render the "+ add" button (only when editable)
    // if (canEdit) {
    //   return [...base, { __rowType: "add_bottom_row", record_index: "__add_bottom_row__" }];
    // }

    return base;
  }, [sheetRecords, canEdit]);

  const toggleSort = (key) => {
    setSortingMeasure((prev) => ({
      ...prev,
      [key]: prev[key] === "asc" ? "desc" : "asc",
    }));
    setSortingParamName(key);
  };

  const renderActionsCell = (row) => {
    if (row.__rowType === "add_top" || row.__rowType === "add_bottom") {
      return (
        <ListingCellRight>
          <Stack direction="row" spacing={1}>
            <HtmlTooltip title={"Save"}>
              <a
                href="#campaignSheetRecordEdit"
                className="cyreen_icons"
                aria-label="validateInlineEntries"
                onClick={(e) => {
                  e.preventDefault();
                  addNewRecord(addNewRow.addFrom);
                }}
              >
                <Done fontSize="small" sx={{ color: "#AF3241", paddingTop: "7px" }} />
              </a>

            </HtmlTooltip>
            <HtmlTooltip title={"Cancel"}>

              <a
                href="#campaignSheetUpload"
                className="cyreen_icons"
                onClick={(e) => {
                  e.preventDefault();
                  cancelAddingNewRow();
                }}
              >
                <Close fontSize="small" sx={{ color: "#AF3241", paddingTop: "7px" }} />
              </a>

            </HtmlTooltip>
          </Stack>

        </ListingCellRight>
      );
    }

    // regular rows
    const isEditingThisRow = editRow === true && editRowIndex === row.record_index;
    const isEditingOtherRow = editRow === true && editRowIndex !== row.record_index;

    return (
      <ListingCellRight>

        {isEditingOtherRow ? (
          <Stack direction="row" spacing={1}>
            <HtmlTooltipDisabled title={"Disabled"}>
              <a
                href="#campaignSheetRecordEdit"
                className="cyreen_icons"
                onClick={(e) => e.preventDefault()}
              >
                <Edit fontSize="small" sx={{ color: "#E6E6E6", paddingTop: "7px" }} />
              </a>
            </HtmlTooltipDisabled>
            <HtmlTooltipDisabled title={"Disabled"}>
              <a
                href="#campaignSheetUpload"
                className="cyreen_icons"
                onClick={(e) => e.preventDefault()}
              >
                <Delete fontSize="small" sx={{ color: "#E6E6E6", paddingTop: "7px" }} />
              </a>
            </HtmlTooltipDisabled>
          </Stack>
        ) : isEditingThisRow ? (
          <Stack direction="row" spacing={1}>
            <HtmlTooltip title={"Save"}>
              <a
                href="#campaignSheetRecordEdit"
                className="cyreen_icons"
                aria-label="validateInlineEntries"
                onClick={(e) => {
                  e.preventDefault();
                  handleFieldChange(row.record_index);
                }}
              >
                <Done fontSize="small" sx={{ color: "#AF3241", paddingTop: "7px" }} />
              </a>
            </HtmlTooltip>
            <HtmlTooltip title={"Cancel"}>
              <a
                href="#campaignSheetUpload"
                className="cyreen_icons"
                onClick={(e) => {
                  e.preventDefault();
                  setEditRow(false);
                  setError(false);
                  setAccuracyErrors({});
                  setEditRowIndex("");
                  setEditedRowValues({});
                  props.setChangesInProgress(false);
                }}
              >
                <Close fontSize="small" sx={{ color: "#AF3241", paddingTop: "7px" }} />
              </a>
            </HtmlTooltip>
          </Stack>
        ) : (
          <Stack direction="row" spacing={1}>
            <HtmlTooltip title={"Edit"}>
              <a
                href="#campaignSheetRecordEdit"
                className="cyreen_icons"
                onClick={(e) => {
                  e.preventDefault();
                  cancelAddingNewRow();
                  setEditRow(true);

                  // ✅ IMPORTANT: use record_index not key
                  setEditRowIndex(row.record_index);

                  props.setChangesInProgress(true);
                  props.setUserInteracted(true);
                  setEditedRowValues({
                    original_record: row,
                    edited_values: row,
                  });
                }}
              >
                <Edit fontSize="small" sx={{ color: "#AF3241", paddingTop: "7px" }} />
              </a>
            </HtmlTooltip>

            <HtmlTooltip title={"Delete"}>
              <a
                href="#campaignSheetUpload"
                className="cyreen_icons"
                onClick={(e) => {
                  e.preventDefault();
                  setShowDeleteModal(true);
                  setProductSelection((prev) => [...prev, row.record_index]);
                }}
              >
                <Delete fontSize="small" sx={{ color: "#AF3241", paddingTop: "7px" }} />
              </a>
            </HtmlTooltip>
          </Stack>
        )}

      </ListingCellRight>
    );
  };

  const columns = React.useMemo(() => {
    const cols = [];

    // ✅ Select checkbox column (only when editable)
    if (canEdit) {
      cols.push({
        id: "select",
        headerAlign: "left",
        align: "left",
        useSmallWidthCell: true,
        cellSx: { width: "50px" },
        headerSx: { width: "50px" },
        header: (
          <ListingCellLeft>
            <StyledWhiteCheckbox
              size="small"
              checked={selectAll}
              onChange={(e) => {
                setSelectAll(e.target.checked);
                checkUncheckAllCheckboxes(e.target.checked);
                if (e.target.checked) {
                  setProductSelection(sheetRecords.map((r) => r.record_index));
                } else {
                  setProductSelection([]);
                }
              }}
            />
          </ListingCellLeft>
        ),
        render: (row) => {
          if (row.__rowType === "add_bottom_row" || row.__rowType === "add_top" || row.__rowType === "add_bottom") return null;

          // if (row.__rowType === "empty_row") return <ListingCellLeft>No Analytics Products added yet</ListingCellLeft>;

          return (
            <ListingCellLeft>
              <StyledCheckbox
                size="small"
                checked={productSelection.includes(row.record_index)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  if (checked) {
                    setProductSelection((prev) => [...prev, row.record_index]);
                  } else {
                    setProductSelection((prev) => prev.filter((id) => id !== row.record_index));
                    setSelectAll(false);
                  }
                }}
              />
            </ListingCellLeft>
          );
        },
      });
    }

    // ✅ Group No.
    cols.push({
      id: "numberAdLevel",
      headerAlign: "left",
      align: "left",
      header: (
        <ListingHeaderContent onClick={() => toggleSort("numberAdLevel")} style={{ cursor: "pointer" }}>
          Group No.
          <SortIcon direction={sortingMeasure.numberAdLevel} />
        </ListingHeaderContent>
      ),
      render: (row) => {
        if (row.__rowType === "add_bottom_row") return null;

        // if (row.__rowType === "empty_row") return null;
        // editing row UI stays the same; just move it into render()
        if (editRow === true && editRowIndex === row.record_index) {
          return (
            <ListingCellLeft>
              <CustomTextInputLeftAligned
                variant="standard"
                fullWidth={true}
                value={editedRowValues?.edited_values?.numberAdLevel ?? ""}
                onChange={(e) =>
                  setEditedRowValues((prev) => ({
                    ...prev,
                    edited_values: { ...prev.edited_values, numberAdLevel: e.target.value },
                  }))
                }
                error={typeof accuracyErrors.numberAdLevel !== "undefined"}
                // helperText={accuracyErrors.numberAdLevel}
                // InputProps={{ sx: { fontSize: "13px" } }}
                InputProps={
                  error === true && typeof accuracyErrors.numberAdLevel !== "undefined"
                    ? {
                      endAdornment: (
                        <InputAdornment position="end">{tooltipError(accuracyErrors.numberAdLevel)}</InputAdornment>
                      ),
                    }
                    : {}
                }
              />
            </ListingCellLeft>
          );
        }

        // add-new row at top/bottom (use your existing newRowValues logic)
        if (row.__rowType === "add_top" || row.__rowType === "add_bottom") {
          return (
            <ListingCellLeft>
              <CustomTextInputLeftAligned
                variant="standard"
                fullWidth={true}
                value={newRowValues.numberAdLevel ?? ""}
                onChange={(e) => setNewRowValues((prev) => ({ ...prev, numberAdLevel: e.target.value }))}
                error={typeof accuracyErrors.numberAdLevel !== "undefined"}
                // helperText={accuracyErrors.numberAdLevel}
                // InputProps={{ sx: { fontSize: "13px" } }}
                InputProps={
                  error === true && typeof accuracyErrors.numberAdLevel !== "undefined"
                    ? {
                      endAdornment: (
                        <InputAdornment position="end">{tooltipError(accuracyErrors.numberAdLevel)}</InputAdornment>
                      ),
                    }
                    : {}
                }
              />
            </ListingCellLeft>
          );
        }

        return <ListingCellLeft>{row.numberAdLevel}</ListingCellLeft>;
      },
    });

    // ✅ Analysis Group Name
    cols.push({
      id: "nameAdLevel",
      cellSx: { width: window.screen.width < 1300 ? "190px" : "280px" },
      headerSx: { width: window.screen.width < 1300 ? "190px" : "280px" },
      header: (
        <ListingHeaderContent onClick={() => toggleSort("nameAdLevel")} style={{ cursor: "pointer" }}>
          Analysis Group Name
          <SortIcon direction={sortingMeasure.nameAdLevel} />
        </ListingHeaderContent>
      ),
      render: (row) => {
        if (row.__rowType === "add_bottom_row") return null;

        // if (row.__rowType === "empty_row") return null;

        if (editRow === true && editRowIndex === row.record_index) {
          return (
            <ListingCellLeft>
              <CustomTextInputLeftAligned
                variant="standard"
                fullWidth={true}
                value={editedRowValues?.edited_values?.nameAdLevel ?? ""}
                onChange={(e) =>
                  setEditedRowValues((prev) => ({
                    ...prev,
                    edited_values: { ...prev.edited_values, nameAdLevel: e.target.value },
                  }))
                }
                error={typeof accuracyErrors.nameAdLevel !== "undefined"}
                helperText={accuracyErrors.nameAdLevel}
                // InputProps={{ sx: { fontSize: "13px" } }}
                InputProps={
                  error === true && typeof accuracyErrors.nameAdLevel !== "undefined"
                    ? {
                      endAdornment: (
                        <InputAdornment position="end">{tooltipError(accuracyErrors.nameAdLevel)}</InputAdornment>
                      ),
                    }
                    : {}
                }
              />
            </ListingCellLeft>
          );
        }

        if (row.__rowType === "add_top" || row.__rowType === "add_bottom") {
          return (
            <ListingCellLeft>
              <CustomTextInputLeftAligned
                variant="standard"
                value={newRowValues.nameAdLevel ?? ""}
                fullWidth={true}
                onChange={(e) => setNewRowValues((prev) => ({ ...prev, nameAdLevel: e.target.value }))}
                error={typeof accuracyErrors.nameAdLevel !== "undefined"}
                // helperText={accuracyErrors.nameAdLevel}
                // InputProps={{ sx: { fontSize: "13px" } }}
                InputProps={
                  error === true && typeof accuracyErrors.nameAdLevel !== "undefined"
                    ? {
                      endAdornment: (
                        <InputAdornment position="end">{tooltipError(accuracyErrors.nameAdLevel)}</InputAdornment>
                      ),
                    }
                    : {}
                }
              />
            </ListingCellLeft>
          );
        }

        return <ListingCellLeft>{row.nameAdLevel}</ListingCellLeft>;
      },
    });

    // ✅ Description
    cols.push({
      id: "description",
      cellSx: { width: window.screen.width < 1300 ? "190px" : "280px" },
      headerSx: { width: window.screen.width < 1300 ? "190px" : "280px" },
      header: (
        <ListingHeaderContent onClick={() => toggleSort("description")} style={{ cursor: "pointer" }}>
          Description
          <SortIcon direction={sortingMeasure.description} />
        </ListingHeaderContent>
      ),
      render: (row) => {
        if (row.__rowType === "add_bottom_row") return null;

        // if (row.__rowType === "empty_row") return null;

        if (editRow === true && editRowIndex === row.record_index) {
          return (
            <ListingCellLeft>
              <CustomTextInputLeftAligned
                variant="standard"
                fullWidth={true}
                value={editedRowValues?.edited_values?.description ?? ""}
                onChange={(e) =>
                  setEditedRowValues((prev) => ({
                    ...prev,
                    edited_values: { ...prev.edited_values, description: e.target.value },
                  }))
                }
                error={typeof accuracyErrors.description !== "undefined"}
                // helperText={accuracyErrors.description}
                // InputProps={{ sx: { fontSize: "13px" } }}
                InputProps={
                  error === true && typeof accuracyErrors.description !== "undefined"
                    ? {
                      endAdornment: (
                        <InputAdornment position="end">{tooltipError(accuracyErrors.description)}</InputAdornment>
                      ),
                    }
                    : {}
                }
              />
            </ListingCellLeft>
          );
        }

        if (row.__rowType === "add_top" || row.__rowType === "add_bottom") {
          return (
            <ListingCellLeft>
              <CustomTextInputLeftAligned
                variant="standard"
                fullWidth={true}
                value={newRowValues.description ?? ""}
                onChange={(e) => setNewRowValues((prev) => ({ ...prev, description: e.target.value }))}
                error={typeof accuracyErrors.description !== "undefined"}
                // helperText={accuracyErrors.description}
                // InputProps={{ sx: { fontSize: "13px" } }}
                InputProps={
                  error === true && typeof accuracyErrors.description !== "undefined"
                    ? {
                      endAdornment: (
                        <InputAdornment position="end">{tooltipError(accuracyErrors.description)}</InputAdornment>
                      ),
                    }
                    : {}
                }
              />
            </ListingCellLeft>
          );
        }

        return <ListingCellLeft>{row.description}</ListingCellLeft>;
      },
    });

    // ✅ GTIN
    cols.push({
      id: "gtin",
      // cellSx: { width: "100px" },
      // headerSx: { width: "100px" },
      header: (
        <ListingHeaderContent onClick={() => toggleSort("gtin")} style={{ cursor: "pointer" }}>
          GTIN
          <SortIcon direction={sortingMeasure.gtin} />
        </ListingHeaderContent>
      ),
      render: (row) => {
        if (row.__rowType === "add_bottom_row") return null;

        // if (row.__rowType === "empty_row") return null;

        if (editRow === true && editRowIndex === row.record_index) {
          return (
            <ListingCellLeft>
              <CustomTextInputLeftAligned
                fullWidth={true}
                variant="standard"
                value={editedRowValues?.edited_values?.gtin ?? ""}
                onChange={(e) =>
                  setEditedRowValues((prev) => ({
                    ...prev,
                    edited_values: { ...prev.edited_values, gtin: e.target.value },
                  }))
                }
                error={typeof accuracyErrors.gtin !== "undefined"}
                // helperText={accuracyErrors.gtin}
                // InputProps={{ sx: { fontSize: "13px" } }}
                InputProps={
                  error === true && typeof accuracyErrors.gtin !== "undefined"
                    ? {
                      endAdornment: (
                        <InputAdornment position="end">{tooltipError(accuracyErrors.gtin)}</InputAdornment>
                      ),
                    }
                    : {}
                }
              />
            </ListingCellLeft>
          );
        }

        if (row.__rowType === "add_top" || row.__rowType === "add_bottom") {
          return (
            <ListingCellLeft>
              <CustomTextInputLeftAligned
                variant="standard"
                fullWidth={true}
                value={newRowValues.gtin ?? ""}
                onChange={(e) => setNewRowValues((prev) => ({ ...prev, gtin: e.target.value }))}
                error={typeof accuracyErrors.gtin !== "undefined"}
                // helperText={accuracyErrors.gtin}
                // InputProps={{ sx: { fontSize: "13px" } }}
                InputProps={
                  error === true && typeof accuracyErrors.gtin !== "undefined"
                    ? {
                      endAdornment: (
                        <InputAdornment position="end">{tooltipError(accuracyErrors.gtin)}</InputAdornment>
                      ),
                    }
                    : {}
                }
              />
            </ListingCellLeft>
          );
        }

        return <ListingCellLeft>{row.gtin}</ListingCellLeft>;
      },
    });

    // bundle size
    cols.push(
      {
        id: "bundleSize",
        header: "Bundle Size",
        // cellSx: { width: "80px" },
        // headerSx: { width: "80px" },
        render: (row) => {
          if (row.__rowType === "add_bottom_row") return null;

          // if (row.__rowType === "empty_row") return null;

          const isEditing = editRow === true && editRowIndex === row.record_index;

          if (isEditing) {
            return (
              <ListingCellLeft>
                <CustomTextInputLeftAligned
                  variant="standard"
                  margin="none"
                  fullWidth
                  name="bundle_size_text"
                  type="text"
                  value={editedRowValues.edited_values.bundleSize}
                  onChange={(e) => {
                    setEditedRowValues({
                      ...editedRowValues,
                      edited_values: {
                        ...editedRowValues.edited_values,
                        bundleSize: e.target.value.trim(),
                      },
                    });
                  }}
                  error={error === true && typeof accuracyErrors.bundleSize !== "undefined"}
                  InputProps={
                    error === true && typeof accuracyErrors.bundleSize !== "undefined"
                      ? {
                        endAdornment: (
                          <InputAdornment position="end">{tooltipError(accuracyErrors.bundleSize)}</InputAdornment>
                        ),
                      }
                      : {}
                  }
                />
              </ListingCellLeft>
            );
          }

          if (row.__rowType === "add_top" || row.__rowType === "add_bottom") {
            return (
              <ListingCellLeft>
                <CustomTextInputLeftAligned
                  variant="standard"
                  fullWidth={true}
                  value={newRowValues.bundleSize ?? ""}
                  onChange={(e) => setNewRowValues((prev) => ({ ...prev, bundleSize: e.target.value }))}
                  error={typeof accuracyErrors.bundleSize !== "undefined"}
                  // helperText={accuracyErrors.bundleSize}
                  // InputProps={{ sx: { fontSize: "13px" } }}
                  InputProps={
                    error === true && typeof accuracyErrors.bundleSize !== "undefined"
                      ? {
                        endAdornment: (
                          <InputAdornment position="end">{tooltipError(accuracyErrors.bundleSize)}</InputAdornment>
                        ),
                      }
                      : {}
                  }
                />
              </ListingCellLeft>
            );
          }

          return <ListingCellLeft>{row.bundleSize}</ListingCellLeft>;
        },
      }
    );

    // ✅ Action column (edit/save/delete + bottom add icon)
    if (canEdit) {
      cols.push({
        id: "actions",
        header: "Action",
        headerAlign: "right",
        align: "right",
        render: (row) => {
          return renderActionsCell(row);
        },
      });
    }

    return cols;
  }, [
    canEdit,
    selectAll,
    productSelection,
    sheetRecords,
    editRow,
    editRowIndex,
    editedRowValues,
    newRowValues,
    addNewRow,
    accuracyErrors,
    sortingMeasure,
    sortingParamName,
  ]);


  return (
    <>
      <Box>
        <Stack direction={"row"} spacing={4}>
          <h3>Existing analytics products</h3>
        </Stack>
        <Box height={40} />
        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
          <Box width={300}>
            <CustomTextInput
              variant="standard"
              fullWidth
              label="Search"
              placeholder="Search"
              type={"text"}
              autoComplete="off"
              value={searchVal.value}
              onChange={(e) => {
                setSearchVal({ value: e.target.value });
              }}
              onBlur={(e) => { }}
            />
          </Box>
          {/* ------------ add new row and delete button ---------- */}
          <Box display="flex" alignItems="center" ml={2}>
            <Stack direction={"row"} spacing={2}>
              {readCampaignStatus === "requested" && (
                <>
                  {/* delete selected rows */}
                  {productSelection.length !== 0 ? (
                    <CloseButton
                      onClick={(e) => {
                        e.preventDefault();
                        setShowDeleteModal(true);
                      }}
                      label={"Delete Selected (" + productSelection.length + ")"}
                      icon={<Delete />}
                    />
                  ) : (
                    <DisabledGreyButton
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                      label="Delete Selected (0)"
                      icon={<Delete />}
                    />
                  )}

                  {/* ------ add new adlevel row ------- */}
                  {(addNewRow.add === true && addNewRow.addFrom === "top") || editRow === true ? (
                    <DisabledGreyButton
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                      label="Add new"
                      icon={<Add />}
                    />
                  ) : (
                    <ActionButton
                      onClick={(e) => {
                        e.preventDefault();
                        cancelAddingNewRow();
                        props.setChangesInProgress(true);
                        props.setUserInteracted(true);
                        setAddNewRow({
                          add: true,
                          addFrom: "top",
                        });
                      }}
                      label="Add new"
                      icon={<Add />}
                    />
                  )}
                </>
              )}
            </Stack>
          </Box>
        </Box>
        <Box height={20} />
        {/* ------- show data from uploaded sheet --------- */}
        <ListingDataTableForModal
          columns={columns}
          rows={rows}
          rowKey={(row) => row.record_index ?? row.__rowType}
          emptyText="No Analytics Products added yet"
          footer={null}
          tableLayout={"fixed"}
        />
        {/* ------------- add new row button ---------- */}
        {
          canEdit && (
            <Box display="flex" justifyContent="flex-end">
              {(addNewRow.add === true && addNewRow.addFrom === "bottom") || editRow === true ? (
                <HtmlTooltipDisabled title={"Disabled"}>
                  <IconContainer>
                    <a
                      href="#campaignSheetRecordEdit"
                      className="cyreen_icons"
                      onClick={(e) => e.preventDefault()}
                    >
                      <AddCircle fontSize="small" sx={{ color: "#E6E6E6", paddingTop: "7px" }} />
                    </a>
                  </IconContainer>
                </HtmlTooltipDisabled>
              ) : (
                <HtmlTooltip title={"Add New"}>
                  <IconContainer>
                    <a
                      href="#campaignSheetRecordEdit"
                      className="cyreen_icons"
                      onClick={(e) => {
                        e.preventDefault();
                        cancelAddingNewRow();
                        props.setChangesInProgress(true);
                        props.setUserInteracted(true);
                        setAddNewRow({ add: true, addFrom: "bottom" });
                      }}
                    >
                      <AddCircle fontSize="small" sx={{ color: "#AF3241", paddingTop: "7px" }} />
                    </a>
                  </IconContainer>
                </HtmlTooltip>
              )}
            </Box>
          )
        }

        {/* --------- record count info --------- */}
        <Box height={15} />
        <Pagination
          totalCount={listingRecords.length}
          reduxStartKeyword="analysis_import_start"
          reduxEndKeyword="analysis_import_end"
          rightEndBlockConfig={() => {
            return (
              <DownloadCSV
                csvData={sortedResults(listingRecords)}
                csvHeaders={csvHeaders}
                filename={
                  typeof sheetDetails.campaign_detail !== "undefined"
                    ? "export_" + sheetDetails.campaign_detail.campaign_name.replaceAll(" ", "_") + "_products.csv"
                    : "products.csv"
                }
              />
            )
          }}
          scrollContainerRef={props.containerRef}
        />
        <Box height={40} />
      </Box>

      {/* ----------- delete adlevel confirmation modal -------- */}
      {showDeleteModal === true && (
        <CommonConfirmation
          confirmationActionCall={() => {
            deleteSelectedItems();
          }}
          closePopup={(e) => {
            setShowDeleteModal(false);
          }}
          confirmTitle="Delete Analytics Product(s)"
          showConfirmationPopup={showDeleteModal}
          confirmationMessage="Are you sure you want to delete the selected Analytics Product(s)"
        />
      )}
    </>
  );
};

export default AdlevelSheetResults;
